class AlertClass{
    constructor(){
        this.main = document.getElementById('alert');

        this._icon = this.main.querySelector('.icon');
        this._title = this.main.querySelector('.title');
        this._description = this.main.querySelector('.description');
        this._acceptBtn = this.main.querySelector('.accept_btn');

        this._resolveFunction = null;

        this._isOpen = false;
        
        this._acceptBtn.addEventListener('click', this._onClickAcceptBtn.bind(this));
    }

    show(icon, title, description = null, btnText = 'Got it!'){
        this._isOpen = true;

        this._title.innerHTML = title;
        
        if(description == null){
            this._description.style.display = 'none';
        }else{
            this._description.style.display = 'block';
            this._description.innerHTML = description;
        }
        
        switch(icon){
            case 'warning':
                this._icon.src = `${IMG_PATH}icons/alert/warning.svg`;
                this._icon.width = 60;
            break;
            case 'warning-orange':
                this._icon.src = `${IMG_PATH}icons/alert/warning-orange.svg`;
                this._icon.width = 60;
            break;
            case 'warning-blue':
                this._icon.src = `${IMG_PATH}icons/alert/warning-blue.svg`;
                this._icon.width = 60;
            break;
            case 'success':
                this._icon.src = `${IMG_PATH}icons/alert/success.svg`;
                this._icon.width = 60;
            break;
            case 'list-tick':
                this._icon.src = `${IMG_PATH}icons/alert/list-tick.svg`;
                this._icon.width = 60;
            break;
            case 'warning-duplicate':
                this._icon.src = `${IMG_PATH}icons/alert/warning-duplicate.svg`;
                this._icon.width = 100;
            break;
            case 'price-changed':
                this._icon.src = `${IMG_PATH}icons/alert/price-changed.svg`;
                this._icon.width = 80;
            break;
            case 'campaigns':
                this._icon.src = `${IMG_PATH}icons/alert/campaigns.svg`;
                this._icon.width = 80;
            break;
            case 'info':
            default:
                this._icon.src = `${IMG_PATH}icons/alert/info.svg`;
                this._icon.width = 60;
            break;        
        }

        this._acceptBtn.innerHTML = btnText;
        
        document.body.classList.add('block-scroll');
        this.main.classList.add('modal--show');
        
        setTimeout(()=>{
            this.main.classList.add('modal--anim');
        }, 100);


        return new Promise((resolve, reject)=>{
            this._resolveFunction = resolve;
        })
    }

    hide(){
        if(this._isOpen){
            this._isOpen = false;
            
            this.main.classList.remove('modal--anim');

            setTimeout(()=>{
                this.main.classList.remove('modal--show');
                document.body.classList.remove('block-scroll');
            }, 750);
            
            this._resolveFunction(false);
        }        
    }

    get isOpen(){
        return this._isOpen;
    }

    _onClickAcceptBtn(e){
        e.preventDefault();
        e.stopPropagation();
        
        this._isOpen = false;

        this.main.classList.remove('modal--anim');

        setTimeout(()=>{
            this.main.classList.remove('modal--show');
            document.body.classList.remove('block-scroll');
        }, 750);

        this._resolveFunction(true);
    }
}

const Alert = new AlertClass();

Object.seal(Alert);

export default Alert;